import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { DisplayText } from '../display-text/display-text';
import { Icon } from '../icon/icon';
const b = bemClassBuilder('v-message');
export const Message = observer(props => {
    const { iconName, title, description, className, children } = props;
    return (_jsxs("div", Object.assign({ className: b.block(undefined, className) }, { children: [iconName && _jsx(Icon, { className: b.element('icon'), name: iconName }), title && _jsx("h2", Object.assign({ className: b.element('title') }, { children: title })), description && _jsx(DisplayText, { className: b.element('description'), label: description }), children] })));
});
Message.displayName = 'Message';
